/**
 * Die Liste der HUD-Teile. Ein neues Anzeigeelement ist eine neue Datei plus
 * eine Zeile hier — `main.ts` bleibt unberührt.
 */

import { balken } from './balken.js';
import { kopf } from './kopf.js';
import { meldungen } from './meldungen.js';
import { schalter } from './schalter.js';
import { slots } from './slots.js';
import { abschluss, wahl } from './dialoge.js';
import type { HudTeil } from './typen.js';

export const HUD: readonly HudTeil[] = [
  balken,
  slots,
  kopf,
  meldungen,
  schalter,
  abschluss,
  wahl,
];

export { setzeErtrag } from './dialoge.js';
export { hinweis } from './schalter.js';
export { overlayOffen } from './typen.js';
export type { HudTeil, HudUmgebung } from './typen.js';
